<form #f="ngForm" class="wcm-erp modal-view">
  <app-wcm-table [api]="api" [filters]="localFilters"
                 refreshSignal="company-invoice-notes-list-refresh"
                 [hidePaginator]="true" [hideTableFilters]="true">
    <ng-template appWcmHeaderTitle text="Mentions légales"></ng-template>
    <ng-template appWcmHeaderRight>
      <button class="btn btn-default" type="button"
              *ngIf="hasPermissions('Antoine:TaxationDataAdmin')"
              (click)="showAddForm()"
              [disabled]="editionInProgress || loadingItemAction">
        <i class="fas fa-plus"></i> Affecter une mention
      </button>
    </ng-template>

    <app-wcm-col field="code" header="Code" class="sm-v-padding text-left" headerClass="text-left"
                 [preventSort]="true" type="none" width="150">
      <ng-template appWcmColBody let-item="item">
        <p class="form-control-static" *ngIf="!item.editable">{{ item.code }}</p>
        <input class="form-control wcm-highlight-req" [required]="true"
               *ngIf="item.editable && hasPermissions('Antoine:TaxationDataAdmin')"
               name="{{'code_' + item.id}}"
               [(ngModel)]="item.code"/>
      </ng-template>
    </app-wcm-col>

    <app-wcm-col field="content" header="Contenu" class="sm-v-padding text-left" headerClass="text-left"
                 [preventSort]="true" type="none">
      <ng-template appWcmColBody let-item="item">
        <p class="form-control-static" *ngIf="!item.editable">{{ item.content }}</p>
        <textarea class="form-control wcm-highlight-req" [required]="true" rows="3"
                  *ngIf="item.editable && hasPermissions('Antoine:TaxationDataAdmin')"
                  name="{{'content_' + item.id}}"
                  [(ngModel)]="item.content">
        </textarea>
      </ng-template>
    </app-wcm-col>

        <app-wcm-col field="content" header="Position" class="sm-v-padding text-left" headerClass="text-left"
                 [preventSort]="true" type="none">
      <ng-template appWcmColBody let-item="item">
          <p class="form-control-static" *ngIf="!item.editable && hasPermissions('Antoine:TaxationDataAdmin')">{{ item.position }}</p>
        <input class="form-control wcm-highlight-req" [required]="true"
               *ngIf="item.editable && hasPermissions('Antoine:TaxationDataAdmin')"
               name="{{'position_' + item.id}}"
               [(ngModel)]="item.position"/>
      </ng-template>
    </app-wcm-col>

    <app-wcm-col header="Action" id="action" type="none" class="text-right" [preventSort]="true" width="120">
      <ng-template appWcmColBody let-item="item">
        <div class="action-btn-bar">
          <button class="btn btn-default btn-xs" title="Editer"
                  (click)="edit(item)" type="button"
                  *ngIf="!item.editable && !editionInProgress && hasPermissions('Antoine:TaxationDataAdmin')"
                  [disabled]="loadingItemAction">
            <i class="fas fa-pencil-alt"></i>
          </button>

          <button class="btn btn-default btn-xs" title="Supprimer"
                  (click)="confirmDelete(item)" type="button"
                  *ngIf="!item.editable && !editionInProgress && hasPermissions('Antoine:TaxationDataAdmin')"
                  [disabled]="loadingItemAction">
            <i class="fa fa-trash-alt"></i>
          </button>

          <button class="btn btn-default btn-xs" title="Enregistrer"
                  (click)="save(item)" type="submit"
                  *ngIf="item.editable && hasPermissions('Antoine:TaxationDataAdmin')"
                  [disabled]="loadingItemAction || f.form.invalid">
            <i class="fas fa-check"></i>
          </button>

          <button class="btn btn-default btn-xs" title="Annuler"
                  (click)="cancelEdit(item)" type="button"
                  *ngIf="item.editable && hasPermissions('Antoine:TaxationDataAdmin')" [disabled]="loadingItemAction">
            <i class="fas fa-undo"></i>
          </button>
        </div>
      </ng-template>
    </app-wcm-col>
  </app-wcm-table>

  <div class="form-group row" *ngIf="newNote">
    <label class="col-sm-2 control-label">Nouveau code</label>
    <div class="col-sm-3">
      <input class="form-control" name="new_code" [(ngModel)]="newNote.code" placeholder="ex: AAB">
    </div>
    <label class="col-sm-2 control-label">Contenu</label>
    <div class="col-sm-5">
      <textarea class="form-control" name="new_content" rows="2" [(ngModel)]="newNote.content"></textarea>
    </div>
    <label class="col-sm-2 control-label">Position</label>
    <div class="col-sm-5">
      <textarea class="form-control" name="new_content" rows="2" [(ngModel)]="newNote.position"></textarea>
    </div>
  </div>
  <div class="form-group row" *ngIf="newNote">
    <div class="col-sm-offset-2 col-sm-10">
      <button class="btn btn-primary" type="button" (click)="addInvoiceNote()"
              [disabled]="loadingItemAction || !newNote.code || !newNote.content">
        Enregistrer
      </button>
      <button class="btn btn-default" type="button" (click)="cancelAdd()" [disabled]="loadingItemAction">
        Annuler
      </button>
    </div>
  </div>
</form>
